<template>
  <div>
    <div class="content-outer" :class="( $route.name && $route.name == 'incidentExternalAction' ) ? ' m-0 p-0' : ''">
      <b-container>
        <b-row v-if="( $route.name && $route.name == 'incidentExternalAction' )">
          <b-col cols="12">          
            <img class="login-logo incident-logo" :src="shopTalkImg"/>
          </b-col>
          <b-col cols="12"> 
            <div class="incident-title"><h2 class="login-title mb-0 text-center">Incident Action</h2></div>         
          </b-col>
        </b-row>
        <b-row v-if="validToken" class="incidentActionContainerOuter">
          <b-col md="8" class="incidentActionContainer">
            <span class="dTitle title">Title :</span>
            <span class="dData">{{ incidentData.title }}</span>
          </b-col>
          <b-col md="4" class="incidentActionContainer">
            <div><label class="dTitle sev">Severity :</label></div>
            <b-form-select v-if="!hideFeedbackForm && pageType == 'incident-action'" v-model="feedbackData.severity" :options="severityOption" :disabled="( $route.name && $route.name == 'incidentExternalAction' )"></b-form-select>
            <span v-else class="dData">{{ feedbackData.severity }}</span>
          </b-col>
          <b-col md="4" class="incidentActionContainer">
            <span class="dTitle">Category :</span>
            <span class="dData">{{ incidentData.category }}</span>
          </b-col>
          <b-col md="4" class="incidentActionContainer">
            <span class="dTitle station">Station :</span>
            <span class="dData">{{ incidentData.station ? incidentData.station.split(" - ")[0] : "N/A" }}</span>
          </b-col>
          <b-col md="4" class="incidentActionContainer">
            <span class="dTitle">Reported By :</span>
            <span class="dData">{{ incidentData.reportedBy }}</span>
          </b-col>
          <b-col md="12" class="incidentActionContainer def-func-input-form-group def-func-input-group">
            <span class="dTitle desc">Description :</span>
            <span class="dData">{{ incidentData.description }}</span>
          </b-col>
          <b-col md="6" class="incidentActionContainer" v-if="pageType == 'incident-view' && (userRole.includes('MANAGER') || isRegionalManager)" >
            <span class="dTitle">Root Cause :</span>
            <span class="dData">{{ incidentData.rootcause }}</span>
          </b-col> 
          <b-col md="6" class="incidentActionContainer" v-if="pageType == 'incident-view' && (userRole.includes('MANAGER') || isRegionalManager)" >
            <span class="dTitle">Root Cause Sub :</span>
            <span class="dData">{{ incidentData.rootcause_sub }}</span>
          </b-col>
          <b-col cols="auto" class="incidentActionContainer pr0" v-if="pageType == 'incident-view' && isRegionalManager" >
            <span class="dTitle">Risk Assessment and Treatment :</span>
          </b-col>
          <template v-if="!incidentData.risk_assessment_comments && !incidentData.risk_assessment_severity && !incidentData.risk_assessment_probability && !incidentData.risk_assessment_index && !incidentData.risk_treatment_comments && !incidentData.risk_treatment_severity && !incidentData.risk_treatment_probability && !incidentData.risk_treatment_index">
            <b-col cols="6" class="incidentActionContainer pl0" v-if="pageType == 'incident-view' && isRegionalManager">
              <span class="dData">
                Risk Assessment and Treatment has been skipped
              </span>
            </b-col>
          </template>
          <template v-else>
            <b-col cols="12" class="incidentActionContainer" v-if="pageType == 'incident-view' && isRegionalManager">
              <b-row>
                <b-col md="12" class="incidentActionContainer" v-if="pageType == 'incident-view' && isRegionalManager" >
                  <span class="dTitle">Existing Safety Controls :</span>
                  <span class="dData" v-html="incidentData.risk_assessment_comments ? incidentData.risk_assessment_comments.replace(/\n/g, '<br>') : ''"></span>
                </b-col>
                <b-col md="3" class="incidentActionContainer" v-if="pageType == 'incident-view' && isRegionalManager" >
                  <span class="dTitle">Severity :</span>
                  <span class="dData">{{ incidentData.risk_assessment_severity }}</span>
                </b-col>
                <b-col md="3" class="incidentActionContainer" v-if="pageType == 'incident-view' && isRegionalManager" >
                  <span class="dTitle">Probability :</span>
                  <span class="dData">{{ incidentData.risk_assessment_probability }}</span>
                </b-col>
                <b-col md="3" class="incidentActionContainer" v-if="pageType == 'incident-view' && isRegionalManager" >
                  <span class="dTitle">Initial Risk Index :</span>
                  <span 
                    class="dData"
                    :class="incidentData.risk_assessment_colour === 'red' ? 'riskIndex-unacceptable' 
                            : incidentData.risk_assessment_colour === 'yellow' ? 'riskIndex-review'
                            : incidentData.risk_assessment_colour === 'green' ? 'riskIndex-acceptable' : ''"
                  >{{ incidentData.risk_assessment_index }}</span>
                </b-col>
                <b-col md="3" class="incidentActionContainer" v-if="pageType == 'incident-view' && isRegionalManager" >
                  <span class="dTitle">Initial Risk Date :</span>
                  <span class="dData">{{ incidentData.risk_assessment_date | moment }}</span>
                </b-col>
                <b-col md="12" class="incidentActionContainer" v-if="pageType == 'incident-view' && isRegionalManager">
                  <span class="dTitle">Risk Action :</span>
                  <span class="dData">{{ incidentData.risk_assessment_action }}</span>
                </b-col>
                <b-col md="12" class="incidentActionContainer" v-if="pageType == 'incident-view' && isRegionalManager" >
                  <span class="dTitle">Mitigation Control :</span>
                  <span class="dData" v-html="incidentData.risk_treatment_comments ? incidentData.risk_treatment_comments.replace(/\n/g, '<br>') : ''"></span>
                </b-col>
                <b-col md="3" class="incidentActionContainer" v-if="pageType == 'incident-view' && isRegionalManager" >
                  <span class="dTitle">Severity :</span>
                  <span class="dData">{{ incidentData.risk_treatment_severity }}</span>
                </b-col>
                <b-col md="3" class="incidentActionContainer" v-if="pageType == 'incident-view' && isRegionalManager" >
                  <span class="dTitle">Probability :</span>
                  <span class="dData">{{ incidentData.risk_treatment_probability }}</span>
                </b-col>
                <b-col md="3" class="incidentActionContainer" v-if="pageType == 'incident-view' && isRegionalManager" >
                  <span class="dTitle">Residual Risk Index :</span>
                  <span
                    class="dData"
                    :class="incidentData.risk_treatment_colour === 'red' ? 'riskIndex-unacceptable' 
                            : incidentData.risk_treatment_colour === 'yellow' ? 'riskIndex-review'
                            : incidentData.risk_treatment_colour === 'green' ? 'riskIndex-acceptable' : ''"
                  >{{ incidentData.risk_treatment_index }}
                  </span>
                </b-col>
                <b-col md="3" class="incidentActionContainer" v-if="pageType == 'incident-view' && isRegionalManager" >
                  <span class="dTitle">Residual Risk Date :</span>
                  <span class="dData">{{ incidentData.risk_treatment_date | moment }}</span>
                </b-col>
                <b-col md="12" class="incidentActionContainer" v-if="pageType == 'incident-view' && isRegionalManager">
                  <span class="dTitle">Risk Action :</span>
                  <span class="dData">{{ incidentData.risk_assessment_action }}</span>
                </b-col>
              </b-row>
            </b-col>
          </template>
          <b-col md="12" class="incidentActionContainer attCol" v-if="incidentData.attachments.length > 0">
            <div class="att"><span class="dTitle">Attachement :</span></div>
            <div>
              <b-row class="incidentActionImages">
                <b-col xl="1" lg="2" md="2" sm="3" cols="4" class="imgcard" v-for="( imgData, imgIndex ) in incidentData.attachments" :key="imgIndex">
                  <b-card :img-src="imgData.path" img-alt="Card image" img-top class="mb-3">
                    <div class="attachmentImghover">
                      <b-icon v-if="imgData.format != 'application/pdf'" v-b-modal="'attachmentModal-' + imgIndex" icon="eye-fill" variant="#0e3d69"></b-icon>
                      <a :href="imgData.fileURL" download rel="noopener noreferrer" target="_blank">
                        <img src="@/assets/images/download-blue.png" title="Download" />
                      </a>
                      <b-modal :id="'attachmentModal-' + imgIndex" title="Attachments" hide-footer modal-class="flipModal manage-user-modal attModal">
                        <img :src="imgData.path" title="Attachment" />
                      </b-modal>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col md="12" class="d-flex">
            <b-button
              v-if="showResendButton"
              class="resend-btn"
              variant="light"
              @click="resendFeedback"
            >
              Resend Email
            </b-button>
            <b-button
              v-if="showReminderButton"
              class="resend-btn"
              variant="light"
              @click="resendFeedback"
            >
              Reminder Email
            </b-button>
          </b-col>
        </b-row>
        <b-row v-if="validToken">
          <b-col>
            <div class="def-func-input-form-group">
              <div class="def-func-input-group mt-4 mb-0">
                <div class="def-func-input-group-col width-12">
                  <label class="global-freq freq-resp-title">Incident Progress & Updates</label>
                </div>
              </div>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="def-func-table manage-users-table">
              <table>
                <thead>
                  <tr>
                    <th class="text-left"><span> Date </span></th>
                    <th class="text-left"><span> Feedback Provided By Manager/User </span></th>
                    <th class="text-center"><span> Status </span></th>
                    <th class="text-left"><span> Manager/User Name </span></th>
                    <th class="text-left"><span> Assigned To </span></th>
                    <th class="text-center"><span> Attachment </span></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="( row, index ) in feedbackDetails" :key="index">
                    <td class="text-left">{{ row.feedback_date | moment }}</td>
                    <td class="text-left">{{ row.comments }}</td>
                    <td class="text-center">{{ row.status }}</td>
                    <td class="text-left">{{ row.assigned_by }}</td>
                    <td class="text-left">{{ row.assigned_to }}</td>
                    <td class="text-center">
                      <b-icon v-if="row.attachments.length > 0" icon="eye" v-b-modal="'feedbackAttachment-' + index" />
                      <b-modal :id="'feedbackAttachment-' + index" title="Attachments" modal-class="flipModal manage-user-modal" hide-footer centered>
                        <template>
                          <div>
                            <b-carousel :id="'carousel-' + index" v-model="slide" :interval="4000" controls indicators
                                background="#ababab" img-width="1024" img-height="480" style="text-shadow: 1px 1px 2px #333;">
                              <b-carousel-slide v-for="( data, key ) in row.attachments" :key="key" :img-src="data.path" :img-blank="( data.format == 'application/pdf' ) ? true : false" :class="( data.format == 'application/pdf' ) ? 'pdf-button-container' : ''">
                                <template v-if="data.format == 'application/pdf'">
                                  <a :href="data.fileURL" target="_blank" download><b-button class="pdf-button"><img src="@/assets/images/add-pdf.png" title="Download" class="pdf-button-img"/> Download</b-button></a>
                                </template>
                              </b-carousel-slide>
                            </b-carousel>
                          </div>
                        </template>
                      </b-modal>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>
        <div class="def-func-form" v-if="!hideFeedbackForm && pageType == 'incident-action' && validToken">
          <ValidationObserver ref="observer" v-slot="{ passes }">
            <b-form @submit.prevent="passes( submitFeedback )">
              <div class="def-func-input-form-group mb-0">
                <b-row>
                  <b-col>
                    <div class="def-func-input-group mt-4">
                      <b-row>
                        <b-col md="12" class="issue-editor">
                          <ValidationProvider name="Managers Comments" rules="required" v-slot="{ valid, errors }">
                            <div class="required-field">
                              <label>Manager's/User's Comments</label>
                            </div>
                            <b-form-textarea class="textarea-no-resize"
                              placeholder="Manager's/User's Comments" rows="7" max-rows="10" v-model="feedbackData.comments" no-resize
                              :state="errors[0] ? false : ( valid ? true : null )"></b-form-textarea>
                            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                    </div>
                    <div class="def-func-input-group mt-4">
                      <b-row>
                        <b-col md="6">
                          <ValidationProvider name="Status" rules="required" v-slot="{ valid, errors }">
                            <div class="required-field">
                              <label>Status</label>
                            </div>
                            <b-form-select :state="errors[0] ? false : ( valid ? true : null )" v-model="feedbackData.status"
                              :options="statusOption" :disabled="( $route.name && $route.name == 'incidentExternalAction' )"></b-form-select>
                            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </b-col>
                        <b-col md="6">
                          <div class="required-field label-right">
                            <label>Assign to</label>
                            <div>
                              <b-form-checkbox v-model="feedbackData.assignToType" :disabled="( $route.name && $route.name == 'incidentExternalAction' ) || (feedbackData.status == 'closed' || feedbackData.status == 'saved')" class="check-user" name="user-type" switch size="md"></b-form-checkbox>
                              <label v-if="feedbackData.assignToType">Manager</label>
                              <label v-else>External User</label>
                            </div>
                          </div>
                          <ValidationProvider name="Assign to" :rules="`${ ( feedbackData.status == 'closed' || feedbackData.status == 'saved' ) ? '' : ( feedbackData.assignToType ) ? 'required' : 'required|email' }`" v-slot="{ valid, errors }">
                            <b-form-select v-if="feedbackData.assignToType" :options="assignToOption" :disabled="(feedbackData.status == 'closed' || feedbackData.status == 'saved') || ( $route.name && $route.name == 'incidentExternalAction' )" :state="errors[0] ? false : ( valid ? true : null )" v-model="feedbackData.assign_to"></b-form-select>
                            <span v-else>
                              <typeaheadInternalUser :api="( incidentData.reportedById ) ? 'incident_report_feedbacks/internal_users?station=' + incidentData.stationId + '&reported_by=' + incidentData.reportedById + '&' : 'incident_report_feedbacks/internal_users?station=' + incidentData.stationId + '&' "></typeaheadInternalUser>
                              <b-form-input v-show="false" disabled :state="errors[0] ? false : ( valid ? true : null )" v-model="feedbackData.externalEmail"></b-form-input>
                            </span>
                            <b-form-invalid-feedback class="d-block">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                    </div>
                    <div class="def-func-input-group mt-4" v-if="userRole.includes('MANAGER') || isRegionalManager">
                      <b-row>
                        <b-col md="6">
                          <ValidationProvider :name="'Root Cause'" :rules="rootCauseRules" v-slot="{ valid, errors }">
                            <div class="required-field">
                              <label>Root Cause</label>
                            </div>
                            <b-form-select 
                              :state="errors[0] ? false : (valid ? true : null)" 
                              v-model="feedbackData.rootcause"
                              :options="rootcauseOption"
                              :disabled="!feedbackData.status || feedbackData.status === 'reassigned'"
                            ></b-form-select>
                            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </b-col>
                        <b-col md="6">
                          <ValidationProvider :name="'Root Cause Sub'" :rules="rootCauseSubRules" v-slot="{ valid, errors }">
                            <div class="required-field">
                              <label>Root Cause Sub</label>
                            </div>
                            <b-form-select 
                              :state="errors[0] ? false : (valid ? true : null)" 
                              v-model="feedbackData.rootcause_sub"
                              :options="rootcauseSubOption"
                              :disabled="!feedbackData.status || feedbackData.status === 'reassigned'"
                            ></b-form-select>
                            <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                    </div>
                    <div class="def-func-input-group mt-4">
                      <b-row>
                        <b-col md="12" class="attachment-issue">
                          <div class="justify-content-space-between">
                            <div class="width-100">
                              <ValidationProvider name="Attachment" rules="ext:jpg,png,jpeg,pdf" v-slot="{ errors }">
                                <label>Attachment</label>
                                <b-form-file :file-name-formatter="displayFileName" v-model="imgPath" placeholder="Choose a file or drop it here..." ref="attachments" id="attachments" :state="errorMsg ? false : (imgError ? true : null)"
                                  accept="image/jpeg, image/png, .jpg, .png, .jpeg, .pdf, application/pdf" @input="onFileChange( $event )" drop-placeholder="Drop file here..."></b-form-file>
                                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                <p class="feedback-error" v-show="imgError && !errors[0]">{{ errorMsg }}</p>
                              </ValidationProvider>
                            </div>
                            <div class="ml-3 pt-4 mt-3">
                              <b-icon v-b-tooltip.hover.top="'Only pdf, jpg, jpeg, png allowed'" icon="info" class="info-icon-size"></b-icon>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                    <div
                      class="def-func-input-group mt-4"
                      v-if="isRegionalManager && (feedbackData.status === 'closed' || feedbackData.status === 'saved')"
                    >
                      <br />
                      <hr style="border-top: 2px solid #bbb; margin: 32px 0;" />
                        <div class="d-flex align-items-center mb-4 mt-4">
                          <h4 class="mb-0" style="display: flex; align-items: center;">
                            Risk Assessment and Treatment
                            <span style="display:inline-block; width: 1em;"></span>
                            <b-form-checkbox
                              v-model="feedbackData.skipRisk"
                              class="mb-0"
                              style="margin-left:0; font-size: 1.5rem; color: #003261; padding-top: 5px;"
                              :disabled="feedbackData.status === 'saved'"
                            >
                              <span style="font-size: 1.5rem; color: #003261;">(Skip)</span>
                            </b-form-checkbox>
                          </h4>
                        </div>
                      <div class="def-func-input-group mt-4" v-if="isRegionalManager">
                        <b-row>
                          <b-col cols="12">
                            <h5 class="mb-3 mt-2">Risk Assessment</h5>
                          </b-col>
                          <b-col md="12" class="mb-3">
                            <div class="required-field">
                              <label>Existing Safety Controls</label>
                            </div>
                            <b-form-textarea
                              v-model="feedbackData.riskAssessmentComments"
                              :disabled="feedbackData.skipRisk"
                              placeholder="Enter existing safety controls"
                              rows="3"
                              max-rows="6"
                            ></b-form-textarea>
                          </b-col>
                          <b-col md="3" class="mb-3">
                            <div class="required-field">
                              <label>Severity</label>
                            </div>
                            <b-form-select
                              v-model="feedbackData.riskAssessmentSeverity"
                              :options="riskSeverityOptions"
                              :disabled="feedbackData.skipRisk"
                              placeholder="Select severity"
                            ></b-form-select>
                          </b-col>
                          <b-col md="3" class="mb-3">
                            <div class="required-field">
                              <label>Probability</label>
                            </div>
                            <b-form-select
                              v-model="feedbackData.riskAssessmentProbability"
                              :options="riskProbabilityOptions"
                              :disabled="feedbackData.skipRisk"
                              placeholder="Select probability"
                            ></b-form-select>
                          </b-col>
                          <b-col md="3" class="mb-3">
                            <label>Initial Risk Index</label>
                            <b-form-input
                              v-model="feedbackData.riskAssessmentIndex"
                              placeholder="Initial Risk Index"
                              disabled
                              :class="feedbackData.riskAssessmentColour === 'red' ? 'unacceptable' 
                              : feedbackData.riskAssessmentColour === 'yellow' ? 'review'
                              : feedbackData.riskAssessmentColour === 'green' ? 'acceptable' : ''"
                            ></b-form-input>
                          </b-col>
                          <b-col md="3" class="mb-3">
                            <label>Initial Risk Date</label>
                            <div class="freq-monthly">
                              <b-input-group class="date-field">
                                  <b-input-group-append is-text>
                                    <font-awesome-icon :icon="['far', 'calendar-alt']" />
                                  </b-input-group-append>
                                <Datepicker v-model="feedbackData.riskAssessmentDate" :disabled="feedbackData.skipRisk"></Datepicker>
                              </b-input-group>
                            </div>
                          </b-col>
                          <b-col md="12" class="mb-3">
                            <label>Risk Action</label>
                            <b-form-input
                              v-model="feedbackData.riskAssessmentAction"
                              placeholder="Risk Action"
                              disabled
                            ></b-form-input>
                          </b-col>    
                        </b-row>
                        <b-row>
                          <b-col cols="12">
                            <h5 class="mb-3 mt-2">Risk Treatment</h5>
                          </b-col>
                          <b-col md="12" class="mb-3">
                            <div class="required-field">
                              <label>Mitigation Control</label>
                            </div>  
                            <b-form-textarea
                              v-model="feedbackData.riskTreatmentComments"
                              :disabled="feedbackData.skipRisk"
                              placeholder="Enter mitigation control"
                              rows="3"
                              max-rows="6"
                            ></b-form-textarea>
                          </b-col>
                          <b-col md="3" class="mb-3">
                            <div class="required-field">
                              <label>Severity</label>
                            </div>
                            <b-form-select
                              v-model="feedbackData.riskTreatmentSeverity"
                              :options="riskSeverityOptions"
                              :disabled="feedbackData.skipRisk"
                              placeholder="Select severity"
                            ></b-form-select>
                          </b-col>
                          <b-col md="3" class="mb-3">
                            <div class="required-field">
                              <label>Probability</label>
                            </div>
                            <b-form-select
                              v-model="feedbackData.riskTreatmentProbability"
                              :options="riskProbabilityOptions"
                              :disabled="feedbackData.skipRisk"
                              placeholder="Select probability"
                            ></b-form-select>
                          </b-col>
                          <b-col md="3" class="mb-3">
                            <label>Residual Risk Index</label>
                            <b-form-input
                              v-model="feedbackData.riskTreatmentIndex"
                              placeholder="Residual Risk Index"
                              disabled
                              :class="feedbackData.riskTreatmentColour === 'red' ? 'unacceptable' 
                              : feedbackData.riskTreatmentColour === 'yellow' ? 'review'
                              : feedbackData.riskTreatmentColour === 'green' ? 'acceptable' : ''"
                            ></b-form-input>
                          </b-col>
                          <b-col md="3" class="mb-3">
                            <label>Residual Risk Date</label>
                            <div class="freq-monthly">
                              <b-input-group class="date-field">
                                  <b-input-group-append is-text>
                                    <font-awesome-icon :icon="['far', 'calendar-alt']" />
                                  </b-input-group-append>
                                <Datepicker v-model="feedbackData.riskTreatmentDate" :disabled="feedbackData.skipRisk"></Datepicker>
                              </b-input-group>
                            </div>
                          </b-col>
                          <b-col md="12" class="mb-3">
                            <label>Risk Action</label>
                            <b-form-input
                              v-model="feedbackData.riskTreatmentAction"
                              placeholder="Risk Action"
                              disabled
                            ></b-form-input>
                          </b-col>    
                        </b-row>

                      </div>
                    </div>
                    
                    <div v-if="attachments.length > 0">
                      <b-row class="reportIncidentImages">
                        <b-col md="2" sm="3" cols="4" v-for="( imgData, imgIndex ) in attachments" :key="imgIndex">
                          <b-card :img-src="imgData.path" :img-alt="( imgData.format == 'application/pdf' ) ? 'PDF' : 'Image'" img-top class="mb-3">
                            <b-card-footer class="float-right" @click="onImgDelete( imgIndex )">
                              <img thumbnail src="@/assets/images/delete.png" title="Delete" role="button">
                            </b-card-footer>
                          </b-card>
                        </b-col>
                      </b-row>
                    </div>
                    <div class="def-func-input-form-group">
                      <div class="clearfix"></div>
                      <div class="w-100">
                        <b-button v-if="feedbackData.status !== 'saved'" type="submit" variant="light" class="float-right btn-rename-delete">Update</b-button>
                        <b-button v-if="( ($route.name && $route.name == 'incidentExternalAction') || (feedbackData.status === 'saved') )" type="button" variant="light" @click="submitFeedback( 'save' )" class="float-right btn-rename-delete mr-4">Save</b-button>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-form>
          </ValidationObserver>
        </div>
        <div v-if="!validToken" class="outer_reset outer_404">
          <div class="inner_404">
            <div class="title_404">Invalid Token</div>
            <div class="footer_404">
              <div class="body_404">Redirecting to login page in <strong>{{secondsTimer + 1 | secondText }}</strong></div>
              <b-progress :max="max" height="1.5rem" animated striped>
                <b-progress-bar :value="timerValue" class="progress-label">
                </b-progress-bar>
              </b-progress>
            </div>
          </div>
        </div>
      </b-container>
    </div>
    <div class="text-center spinner-div overlay" v-show="messsage_loader">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>
    <successmsg></successmsg>
    <errormsg></errormsg>
  </div>
</template>
<script>
  import moment from "moment";
  import { HTTP, HTTP_formdata, HTTP_BASE } from "../../../constants/http-common";
  import { BASE_URL_VER } from "../../../constants/app-constants";
  import { EventBus } from "../../../main";
  import typeaheadInternalUser from "../../../components/admin_layouts/dashboard_layouts/typeahead_internal_user";
  import Datepicker from "vuejs-datepicker";
  export default {
    data() {
      return {
        incidentData: {
          title: "",
          category: "",
          station: "",
          description: "",
          reportedBy: "",
          attachments: [],
          stationId: "",
          reportedById: null,
          rootcause: null,
          rootcause_sub: null,
          risk_assessment_severity: null,
          risk_assessment_probability: null,
          risk_assessment_index: null,
          risk_assessment_colour: "",
          risk_assessment_date: null,
          risk_assessment_comments: "",
          risk_treatment_severity: null,
          risk_treatment_probability: null,
          risk_treatment_index: null,
          risk_treatment_colour: "",
          risk_treatment_date: null,
          risk_treatment_comments: "",
        },
        messsage_loader: false,
        feedbackData: {
          incident_public_id: this.$route.params.incidentId,
          severity: null,
          comments: "",
          status: null,
          assign_to: null,
          attachment: false,
          externalEmail: '',
          assignToType: true,
          rootcause: null,
          rootcause_sub: null,
          skipRisk: false,
          riskAssessmentComments: "",
          riskAssessmentSeverity: null,
          riskAssessmentProbability: null,
          riskAssessmentIndex: "",
          riskAssessmentAction: "",
          riskAssessmentColour: "",
          riskAssessmentDate: null,
          riskTreatmentComments: "",
          riskTreatmentSeverity: null,
          riskTreatmentProbability: null,
          riskTreatmentIndex: "",
          riskTreatmentAction: "",
          riskTreatmentColour: "",
          riskTreatmentDate: null
        },
        imgPath: null,
        imgError: "",
        errorMsg: "",
        attachments: [],
        feedbackDetails: [],
        severityOption: [{ value: null, text: "Select", disabled: true }, { value: "High", text: "High" }, { value: "Medium", text: "Medium" }, { value: "Low", text: "Low" }],
        statusOption: [{ value: null, text: "Select", disabled: true }, { value: "reassigned", text: "Re-assigned" }],
        assignToOption: [],
        rootcauseOption: [],
        rootcauseSubOption: [],
        feedbackId: "",
        slide: 0,
        pageType: this.$route.meta.incident_page,
        hideFeedbackForm: false,
        validToken: true,
        secondsTimer: 4,
        timerValue: 0,
        max: 5,
        timer: null,
        shopTalkImg: require(`@/assets/images/shop-talk-logo.png`),
        savedData: "",
        userData: {},
        userRole: "",
        isRegionalManager: false,

        riskSeverityOptions: [
          { value: null, text: "Select", disabled: true },
          { value: "Catastrophic (A)", text: "Catastrophic (A)" },
          { value: "Hazardouz (B)", text: "Hazardouz (B)" },
          { value: "Major (C)", text: "Major (C)" },
          { value: "Minor (D)", text: "Minor (D)" },
          { value: "Negligible (E)", text: "Negligible (E)" }
        ],
        riskProbabilityOptions: [
          { value: null, text: "Select", disabled: true },
          { value: "Extremely Improbable (1)", text: "Extremely Improbable (1)" },
          { value: "Improbable (2)", text: "Improbable (2)" },
          { value: "Remote (3)", text: "Remote (3)" },
          { value: "Occasional (4)", text: "Occasional (4)" },
          { value: "Frequent (5)", text: "Frequent (5)" }
        ],
        riskIndexOptions: [
          { value: null, text: "-", disabled: true },
          { value: "1A Review", text: "1A Review", sevOpt: "Catastrophic (A)", proOpt: "Extremely Improbable (1)", colour: "yellow" },
          { value: "1B Review", text: "1B Review", sevOpt: "Hazardouz (B)", proOpt: "Extremely Improbable (1)", colour: "yellow" },
          { value: "1C Acceptable", text: "1C Acceptable", sevOpt: "Major (C)", proOpt: "Extremely Improbable (1)", colour: "green" },
          { value: "1D Acceptable", text: "1D Acceptable", sevOpt: "Minor (D)", proOpt: "Extremely Improbable (1)", colour: "green" },
          { value: "1E Acceptable", text: "1E Acceptable", sevOpt: "Negligible (E)", proOpt: "Extremely Improbable (1)", colour: "green" },

          { value: "2A Review", text: "2A Review", sevOpt: "Catastrophic (A)", proOpt: "Improbable (2)", colour: "yellow" },
          { value: "2B Review", text: "2B Review", sevOpt: "Hazardouz (B)", proOpt: "Improbable (2)", colour: "yellow" },
          { value: "2C Review", text: "2C Review", sevOpt: "Major (C)", proOpt: "Improbable (2)", colour: "yellow" },
          { value: "2D Acceptable", text: "2D Acceptable", sevOpt: "Minor (D)", proOpt: "Improbable (2)", colour: "green" },
          { value: "2E Acceptable", text: "2E Acceptable", sevOpt: "Negligible (E)", proOpt: "Improbable (2)", colour: "green" },

          { value: "3A Unacceptable", text: "3A Unacceptable", sevOpt: "Catastrophic (A)", proOpt: "Remote (3)", colour: "red" },
          { value: "3B Review", text: "3B Review", sevOpt: "Hazardouz (B)", proOpt: "Remote (3)", colour: "yellow" },
          { value: "3C Review", text: "3C Review", sevOpt: "Major (C)", proOpt: "Remote (3)", colour: "yellow" },
          { value: "3D Review", text: "3D Review", sevOpt: "Minor (D)", proOpt: "Remote (3)", colour: "yellow" },
          { value: "3E Acceptable", text: "3E Acceptable", sevOpt: "Negligible (E)", proOpt: "Remote (3)", colour: "green" },

          { value: "4A Unacceptable", text: "4A Unacceptable", sevOpt: "Catastrophic (A)", proOpt: "Occasional (4)", colour: "red" },
          { value: "4B Unacceptable", text: "4B Unacceptable", sevOpt: "Hazardouz (B)", proOpt: "Occasional (4)", colour: "red" },
          { value: "4C Review", text: "4C Review", sevOpt: "Major (C)", proOpt: "Occasional (4)", colour: "yellow" },
          { value: "4D Review", text: "4D Review", sevOpt: "Minor (D)", proOpt: "Occasional (4)", colour: "yellow" },
          { value: "4E Acceptable", text: "4E Acceptable", sevOpt: "Negligible (E)", proOpt: "Occasional (4)", colour: "green" },

          { value: "5A Unacceptable", text: "5A Unacceptable", sevOpt: "Catastrophic (A)", proOpt: "Frequent (5)", colour: "red" },
          { value: "5B Unacceptable", text: "5B Unacceptable", sevOpt: "Hazardouz (B)", proOpt: "Frequent (5)", colour: "red" },
          { value: "5C Unacceptable", text: "5C Unacceptable", sevOpt: "Major (C)", proOpt: "Frequent (5)", colour: "red" },
          { value: "5D Review", text: "5D Review", sevOpt: "Minor (D)", proOpt: "Frequent (5)", colour: "yellow" },
          { value: "5E Acceptable", text: "5E Acceptable", sevOpt: "Negligible (E)", proOpt: "Frequent (5)", colour: "green" }
        ],
        risk_actions: [
          { value: 'No immediate action required.', matching: 'Acceptable' },
          { value: 'Evaluate and implement controls if necessary. Deadline for implementation of actions shall not be later than 28 days from the moment the risk has been identified.', matching: 'Review' },
          { value: 'Immediate action required to mitigate risk. Deadline for implementation of actions shall not be later than 7 days from the moment the risk has been identified.', matching: 'Unacceptable' }
        ]
      };
    },
    components: {
      typeaheadInternalUser,
      Datepicker
    },
    mounted() {
      console.log('Initial hideFeedbackForm:', this.hideFeedbackForm);
      console.log('Initial validToken:', this.validToken);
      console.log('Initial pageType:', this.pageType);
      this.rootcauseOption = [{ value: null, text: "Select", disabled: true }];
      this.rootcauseSubOption = [{ value: null, text: "Select", disabled: true }];
      console.log('before calling incident_report_rootcauses' );
      HTTP_BASE.get("incident_report_rootcauses")
        .then(response => {
          let rootCauses = response.data['hydra:member'];
          for (var i = 0; i < rootCauses.length; i++) {
            this.rootcauseOption.push({
              value: rootCauses[i].public_id,
              text: rootCauses[i].category,
              subs: rootCauses[i].subs
            });
          }
          console.log(this.rootcauseOption,'rootcauseOption**************************');
        })
        .catch(err => {
          console.log('error getting incident_report_rootcauses data',err);
        });
      if($cookies.get("uar")) {
        // check if user is regional manager
        HTTP.post( "permissions/check_regional_manager" )
          .then(response => {
            console.log('permissions/check_regional_manager', response);
            if ( response.status == 200 ) {
              this.isRegionalManager = response.data.isRegionalManager;
              console.log(this.isRegionalManager, 'isRegionalManager');
            }
          })
          .catch(err => {
            console.log('error getting permissions/check_regional_manager data',err);
          });
      }
      if ( this.$route.name && this.$route.name == 'incidentExternalAction' ) {
        this.messsage_loader = true
        let jsonData = {
          token: this.$route.params.incidentToken
        };
        axios
          .post( BASE_URL_VER + "users/check_token_validity", jsonData )
          .then(result => {
            this.messsage_loader = false;
            if ( result.data.code == 200 ) {
              this.validToken = true;
              this.incidentDetails();
            }
          })
          .catch(err => {
            this.messsage_loader = false;
            if ( err.response.status == 400 ) {
              this.validToken = false;
                this.timer = setInterval(() => {
                  if ( this.secondsTimer <= -1 ) {
                    clearInterval(this.timer);
                    this.$router.push({path:"/login"})
                  }
                  this.timerValue = this.max - this.secondsTimer;
                  this.secondsTimer -= 1;
                }, 1000)
            }
          });
      } else
        this.incidentDetails();
    },
    beforeMount() {
      const userCookie = this.$cookies.get("user");
      if (userCookie && userCookie.data) {
        this.userData = this.$cookies.get("user").data;
        this.userRole = this.$cookies.get("user").data.roles[0];
      }
    },
    computed: {
      rootCauseRules() {
        return this.feedbackData.status === 'reassigned' ? '' : 'required';
      },
      rootCauseSubRules() {
        return this.feedbackData.status === 'reassigned' ? '' : 'required';
      },
      showResendButton() {
        let showButton = true;
        if(!this.feedbackDetails || this.feedbackDetails.length === 0) {
          return false;
        } else {
          return (
            this.feedbackDetails.length > 0 &&
            this.feedbackDetails[this.feedbackDetails.length -1].status === "Reassigned" &&
            (this.feedbackDetails[this.feedbackDetails.length -1].external_user !== null && this.feedbackDetails[this.feedbackDetails.length -1].external_user != "")
            && this.isRegionalManager
            && showButton
          );
        }
      },
      //showReminderButton display only when logged user is regional manager and this.feedbackDetails[this.feedbackDetails.length -1].status === "Reassigned" and this.feedbackDetails[this.feedbackDetails.length -1].external_user == null
      showReminderButton(){
        let showButton = true;
        if(!this.feedbackDetails || this.feedbackDetails.length === 0) {
          return false;
        } else {
          return (
            this.feedbackDetails.length > 0 &&
            this.feedbackDetails[this.feedbackDetails.length -1].status === "Reassigned" &&
            (this.feedbackDetails[this.feedbackDetails.length -1].external_user == null || this.feedbackDetails[this.feedbackDetails.length -1].external_user == "")
            && this.isRegionalManager
            && showButton
          );
        }
      }
    },
    watch: {
      "feedbackData.status": {
        handler( val ) {
          this.feedbackData.assign_to = ( val == 'closed' || val == 'saved' ) ? null : this.feedbackData.assign_to;
          this.feedbackData.assignToType = ( val == 'closed' || val == 'saved' ) ? true : this.feedbackData.assignToType;
          this.feedbackData.skipRisk = ( val === 'saved') ? false : this.feedbackData.skipRisk;
          deep: true;
        }
      },
      "feedbackData.assignToType": {
        handler( val ) {
          this.feedbackData.externalEmail = "";
          this.feedbackData.assign_to = null;
          this.$nextTick(() => {
            if (this.$refs.observer) {
              this.$refs.observer.reset();
            }
          });
          deep: true;
        }
      },
      'feedbackData.rootcause': function (newVal) {
        console.log(newVal, 'rootcause');
        console.log('this.feedbackData.rootcause', this.feedbackData.rootcause);
        this.$nextTick(() => {
          if (this.rootcauseOption.length > 1) {
            this.updateRootCauseSubOptions(newVal);
          } else {
            console.warn('rootcauseOption is not populated yet.');
          }
        });
      },

      // hideFeedbackForm && pageType == 'incident-action' && validToken
      hideFeedbackForm: {
        handler(newVal) {
          console.log('hideFeedbackForm watcher triggered:', newVal);
        },
        deep: true
      },
      validToken: {
        handler(newVal) {
          console.log('validToken watcher triggered:', newVal);
        },
        deep: true
      },
      pageType: {
        handler(newVal) {
          console.log('pageType watcher triggered:', newVal);
        },
        deep: true
      },
      'feedbackData.riskAssessmentSeverity': function () {
        this.updateRiskAssessmentIndex();
      },
      'feedbackData.riskAssessmentProbability': function () {
        this.updateRiskAssessmentIndex();
      },
      'feedbackData.riskTreatmentSeverity': function () {
        this.updateRiskTreatmentIndex();
      },
      'feedbackData.riskTreatmentProbability': function () {
        this.updateRiskTreatmentIndex();
      },
      'feedbackData.skipRisk'(val) {
        if (val) {
          // Clear all Risk Assessment and Risk Treatment fields
          // Clear and disable all Risk Assessment and Risk Treatment fields
          this.feedbackData.riskAssessmentComments = "";
          this.feedbackData.riskAssessmentSeverity = null;
          this.feedbackData.riskAssessmentProbability = null;
          this.feedbackData.riskAssessmentIndex = "";
          this.feedbackData.riskAssessmentAction = "";
          this.feedbackData.riskAssessmentColour = "";
          this.feedbackData.riskAssessmentDate = null;
          this.feedbackData.riskTreatmentComments = "";
          this.feedbackData.riskTreatmentSeverity = null;
          this.feedbackData.riskTreatmentProbability = null;
          this.feedbackData.riskTreatmentIndex = "";
          this.feedbackData.riskTreatmentAction = "";
          this.feedbackData.riskTreatmentDate = null;
        }
      },
    },
    filters: {
      moment: function(value) {
        console.log('moment filter input:', value);
        if (!value) return '-';
        const m = moment(value, "YYYY-MM-DD HH:mm:ss", true);
        if (m.isValid()) {
          return m.format("DD MMM YYYY");
        }
        const fallback = moment(value);
        if (fallback.isValid()) {
          return fallback.format("DD MMM YYYY");
        }
        return '-';
      },
      secondText(val) {
        return ( val == 1 || val == 0 ) ? val + " second" : val + " seconds"
      }
    },
    methods: {
      incidentDetails() {
        this.messsage_loader = true;
        // HTTP.get( "incident_report/display/" + this.feedbackData.incident_public_id + "?page_name=" + this.pageType )
        let jsonData = {
          flag: ( this.$route.name && this.$route.name == 'incidentExternalAction' ) ? 'external' : 'internal',
          page_name: this.pageType,
          token: ( this.$route.name && this.$route.name == 'incidentExternalAction' ) ? this.$route.params.incidentToken : ""
        }
        let api = ( this.$route.name && this.$route.name == 'incidentExternalAction' ) ? axios.post( BASE_URL_VER + "incident_report/display/" + this.feedbackData.incident_public_id, jsonData ) : HTTP_formdata.post( "incident_report/display/" + this.feedbackData.incident_public_id, jsonData )
          api.then( response => {
            if ( response.status == 200 )  {
              let resp = response.data[0]
              this.messsage_loader = false;
              this.feedbackData.severity = resp.severity;
              if ( resp.flag == 1 ){
                this.statusOption.push({ value: "closed", text: "Closed" })
                this.statusOption.push({ value: "saved", text: "Saved" })
              } else if ( resp.flag == 0 )
                this.statusOption.push({ value: "resolved", text: "Resolved" })
              this.assignToOption = [{ value: null, text: "Select", disabled: true }]
              for ( let i = 0; i < resp.assign_to.length; i++ ) {
                this.assignToOption.push({
                  value: resp.assign_to[i].value,
                  text: resp.assign_to[i].text
                });
              }
              if ( this.$route.name && this.$route.name == 'incidentExternalAction' ) {
                this.feedbackData.status = this.statusOption[1].value;
                this.feedbackData.assign_to = (this.assignToOption.length > 1) ? this.assignToOption[1].value : null;
              }
              this.feedbackDetails = resp.feedback;
              //get risk_assessment_action from risk_actions array
              let risk_assessment_action = '';
              const index1 = resp.risk_assessment_index;
              if(index1) {
                const secondPart1 = index1.split(" ")[1];
                const match1 = this.risk_actions.find(a => a.matching === secondPart1);
                if (match1) {
                  risk_assessment_action = match1.value;
                }
              }
              //get risk_treatment_action from risk_actions array
              let risk_treatment_action = '';
              const index2 = resp.risk_treatment_index;
              if(index2) {
                const secondPart2 = index2.split(" ")[1];
                const match2 = this.risk_actions.find(a => a.matching === secondPart2);
                if (match2) {
                  risk_treatment_action = match2.value;
                }
              }
              this.incidentData = {
                title: resp.title,
                category: resp.category,
                station: resp.station,
                description: resp.description,
                reportedBy: ( resp.reported_by_name ) ? resp.reported_by_name : "Anonymous",
                attachments: resp.attachments,
                stationId: resp.station_public_id,
                reportedById: resp.reported_by_id,
                rootcause: resp.rootcause,
                rootcause_sub: resp.rootcause_sub,
                risk_assessment_comments: resp.risk_assessment_comments,
                risk_assessment_severity: resp.risk_assessment_severity,
                risk_assessment_probability: resp.risk_assessment_probability,
                risk_assessment_index: resp.risk_assessment_index,
                risk_assessment_action: risk_assessment_action,
                risk_assessment_colour: resp.risk_assessment_colour,
                risk_assessment_date: resp.risk_assessment_date,
                risk_treatment_comments: resp.risk_treatment_comments,
                risk_treatment_severity: resp.risk_treatment_severity,
                risk_treatment_probability: resp.risk_treatment_probability,
                risk_treatment_index: resp.risk_treatment_index,
                risk_treatment_action: risk_treatment_action,
                risk_treatment_colour: resp.risk_treatment_colour,
                risk_treatment_date: resp.risk_treatment_date,
              }
              //assign rootcause and rootcause_sub for feedbackData
              // Parse the JSON string if it's a string
              const rootcauseSubs = typeof resp.rootcause_subs === 'string' 
                ? JSON.parse(resp.rootcause_subs) 
                : resp.rootcause_subs;
              // Update rootcauseSubOption
              if(rootcauseSubs && rootcauseSubs.length>0 ){
                this.rootcauseSubOption = [
                  { value: null, text: "Select", disabled: true },
                  ...rootcauseSubs.map(sub => ({
                    value: sub.public_id,
                    text: sub.subcategory
                  }))
                ];
              } else {
                this.rootcauseSubOption = [{ value: null, text: "Select", disabled: true }];
              }
              console.log(resp.rootcause, 'rootcause');
              this.feedbackData.rootcause = resp.rootcause_public_id;
              this.feedbackData.rootcause_sub = resp.rootcause_sub_public_id;
              this.incidentData.attachments.forEach((val) => {
                val.fileURL = val.path;
                val.path = ( val.format == 'application/pdf' ) ? require(`@/assets/images/add-pdf.png`) : val.path;
              });
              this.savedData = resp.saved;
              if ( this.savedData != null ) {
                this.feedbackData.comments = this.savedData.comments;
                this.attachments = this.savedData.attachments;
              }
              this.hideFeedbackForm = ( resp.assign_to.length == 0 && this.$route.name == 'incidentExternalAction' ) ? true : false;
              //if status === 'SAVED' update all feedbackData
              if(resp.status === 'SAVED') {
                console.log('resp', resp);
                this.feedbackData = { 
                  ...this.feedbackData,
                  status: resp.status ? resp.status.toLowerCase() : resp.status,
                  riskAssessmentComments: resp.risk_assessment_comments,
                  riskAssessmentSeverity: resp.risk_assessment_severity,
                  riskAssessmentProbability: resp.risk_assessment_probability,
                  riskAssessmentIndex: resp.risk_assessment_index,
                  riskAssessmentAction: risk_assessment_action,
                  riskAssessmentColour: resp.risk_assessment_colour,
                  riskAssessmentDate: resp.risk_assessment_date,
                  riskTreatmentComments: resp.risk_treatment_comments,
                  riskTreatmentSeverity: resp.risk_treatment_severity,
                  riskTreatmentProbability: resp.risk_treatment_probability,
                  riskTreatmentIndex: resp.risk_treatment_index,
                  riskTreatmentAction: risk_treatment_action,
                  riskTreatmentColour: resp.risk_treatment_colour,
                  riskTreatmentDate: resp.risk_treatment_date,
                };
              }
            }
          })
          .catch(error => {
            console.log('error getting incident_report/display data',error);
            if ( error.response.status == 400 || error.response.status == 403 ) {
              if ( this.$route.name && this.$route.name == 'incidentExternalAction' )
                this.$router.push({ path: "/login" })
              else
                this.$router.push({ path: "/my-incidents" })
            }
          });
      },
      onImgDelete( imgIndex ) {
        if ( !( 'data' in this.attachments[imgIndex] ) ) {
          HTTP_formdata.delete( "incident_report_feedbacks/delete_attachments/" + this.savedData.saved_feedback_id + "?file=" + this.attachments[imgIndex].file )
            .then(response => {
              this.attachments.splice(imgIndex, 1);
            })
            .catch(err => {});
        } else
          this.attachments.splice(imgIndex, 1);
      },
      onFileChange( e ) {
        if (this.attachments.length < 10 ) {
          if ( e && ( e.type == "image/png" || e.type == "image/jpeg" || e.type == "png" || e.type == "jpeg" || e.type == "pdf" || e.type == "application/pdf" ) ) {
            this.imgError = false;
            let file = e;
            let path = ( e.type == "application/pdf" ) ? require(`@/assets/images/add-pdf.png`) : URL.createObjectURL(file);
            this.attachments.push({ path: path, data: file, name: "", format: e.type })
          } else {
            this.imgError = true;
            this.errorMsg = "Select a valid file"
            setTimeout(() => {
              this.imgError = false;
              this.errorMsg = ""
            }, 2000);
          }
        } else {
          this.imgError = true;
          this.errorMsg = "Maximum 10 attachments allowed"
          setTimeout(() => {
            this.imgError = false;
            this.errorMsg = ""
          }, 2000);
        }
        this.imgPath = null;
        document.getElementById('attachments').value = ''
      },
      displayFileName( files ) {
        return "Choose a file or drop it here..." ;//( this.attachments.length < 10 ) ? ( !this.imgError ) ? files[0].name : "Choose a file or drop it here..." : "Choose a file or drop it here..."
      },
      submitFeedback( action ) {
        this.messsage_loader = true;
        this.feedbackData.attachment = ( this.attachments.length == 0 ) ? false : true;
        let feedbackJson = {
          incident_public_id: this.feedbackData.incident_public_id,
          severity: this.feedbackData.severity,
          comments: this.feedbackData.comments,
          status: this.feedbackData.status,
          assign_to: ( this.feedbackData.assignToType ) ? this.feedbackData.assign_to : '',
          external_user: ( this.feedbackData.assignToType ) ? '' : this.feedbackData.externalEmail,
          attachment: this.feedbackData.attachment,
          flag: ( this.$route.name && this.$route.name == 'incidentExternalAction' ) ? 'external' : 'internal',
          token: ( this.$route.name && this.$route.name == 'incidentExternalAction' ) ? this.$route.params.incidentToken : "",
          incident_feedback_saved: ( this.$route.name && this.$route.name == 'incidentExternalAction' ) ? ( this.savedData === null ) ? this.savedData : this.savedData.saved_feedback_id : null,
          update: ( action ) ? false : true,
        }
        //if  role contains Manager add rootcause and rootcause_sub
        if ( this.userRole.includes( "MANAGER" ) || this.isRegionalManager ) {
          feedbackJson.rootcause = this.feedbackData.rootcause;
          feedbackJson.rootcause_sub = this.feedbackData.rootcause_sub;
        }
        // if isRegionalManager and feedbackData.status is closed, and feedbackData.skipRisk, add riskAssessment and riskTreatment data
        if ( this.isRegionalManager && this.feedbackData.status === 'closed' && !this.feedbackData.skipRisk ) {
          feedbackJson.riskAssessmentComments = this.feedbackData.riskAssessmentComments;
          feedbackJson.riskAssessmentSeverity = this.feedbackData.riskAssessmentSeverity;
          feedbackJson.riskAssessmentProbability = this.feedbackData.riskAssessmentProbability;
          feedbackJson.riskAssessmentIndex = this.feedbackData.riskAssessmentIndex;
          feedbackJson.riskAssessmentColour = this.feedbackData.riskAssessmentColour;
          feedbackJson.riskAssessmentDate = this.feedbackData.riskAssessmentDate;
          feedbackJson.riskTreatmentComments = this.feedbackData.riskTreatmentComments;
          feedbackJson.riskTreatmentSeverity = this.feedbackData.riskTreatmentSeverity;
          feedbackJson.riskTreatmentProbability = this.feedbackData.riskTreatmentProbability;
          feedbackJson.riskTreatmentIndex = this.feedbackData.riskTreatmentIndex;
          feedbackJson.riskTreatmentColour = this.feedbackData.riskTreatmentColour;
          feedbackJson.riskTreatmentDate = this.feedbackData.riskTreatmentDate;
        } else if ( this.isRegionalManager && this.feedbackData.status === 'saved') {
          feedbackJson.riskAssessmentComments = this.feedbackData.riskAssessmentComments;
          feedbackJson.riskAssessmentSeverity = this.feedbackData.riskAssessmentSeverity;
          feedbackJson.riskAssessmentProbability = this.feedbackData.riskAssessmentProbability;
          feedbackJson.riskAssessmentIndex = this.feedbackData.riskAssessmentIndex;
          feedbackJson.riskAssessmentColour = this.feedbackData.riskAssessmentColour;
          feedbackJson.riskAssessmentDate = this.feedbackData.riskAssessmentDate;
          feedbackJson.riskTreatmentComments = this.feedbackData.riskTreatmentComments;
          feedbackJson.riskTreatmentSeverity = this.feedbackData.riskTreatmentSeverity;
          feedbackJson.riskTreatmentProbability = this.feedbackData.riskTreatmentProbability;
          feedbackJson.riskTreatmentIndex = this.feedbackData.riskTreatmentIndex;
          feedbackJson.riskTreatmentColour = this.feedbackData.riskTreatmentColour;
          feedbackJson.riskTreatmentDate = this.feedbackData.riskTreatmentDate;
        }
        // if ( this.feedbackData.status == 'closed' ) { feedbackJson.assign_to = ( this.feedbackDetails.length > 0 ) ? this.assignToOption[1].value : null }
        // HTTP_formdata.post( "incident_report_feedbacks/add", feedbackJson )
        let api = ( this.$route.name && this.$route.name == 'incidentExternalAction' ) ? axios.post( BASE_URL_VER + "incident_report_feedbacks/add", feedbackJson ) : HTTP_formdata.post( "incident_report_feedbacks/add", feedbackJson )
          api.then( resp => {
            if ( resp.status == 200 ) {
              if ( this.feedbackData.assignToType && resp.data.assigned_to_group != null ) {
                this.feedbackId = resp.data.public_id;
                this.updatePermission( resp.data.assigned_to_group, feedbackJson.update, feedbackJson.flag );
              } else if ( this.attachments.length > 0 ) {
                this.feedbackId = resp.data.public_id;
                this.attachmentUpload( feedbackJson.update, feedbackJson.flag );
              } else {
                this.messsage_loader = false;
                let respPopUp = {
                  msg: resp.data.message,
                  popup: true
                }
                EventBus.$emit( "success_resp", respPopUp );
                setTimeout(() => {
                  if ( this.$route.name && this.$route.name == 'incidentExternalAction'  ) {
                    this.hideFeedbackForm = ( feedbackJson.update ) ? true : false;
                    this.incidentDetails();
                  } else
                    this.$router.push({ path: "/my-incidents" });
                }, 2000);
              }
            }
          })
          .catch(error => {
            if ( error.response.status == 400 ) {
              this.messsage_loader = false;
              let errorResp = {
                msg: error.response.data.message,
                popup: true
              };
              EventBus.$emit( "error_resp", errorResp );
            }
          });
      },
      async attachmentUpload( update, flag ) {
        let formData = new FormData();
        for ( let index = 0; index < this.attachments.length; index++ ) {
          if ( 'data' in this.attachments[index] ) {
            formData.set( "attachment", this.attachments[index].data );
            let last_file = ( index+1 == this.attachments.length ) ? true : false;
            // HTTP_formdata.post( "incident_report_feedbacks/upload_attachments/" + this.feedbackId + "?last_file=" + last_file + "&update=" + update + "&flag=" + flag, formData )
            let api = ( this.$route.name && this.$route.name == 'incidentExternalAction' ) ? axios.post( BASE_URL_VER + "incident_report_feedbacks/upload_attachments/" + this.feedbackId + "?last_file=" + last_file + "&update=" + update + "&flag=" + flag, formData ) : HTTP_formdata.post( "incident_report_feedbacks/upload_attachments/" + this.feedbackId + "?last_file=" + last_file + "&update=" + update + "&flag=" + flag, formData )
            await api.then(response => {
                if ( index + 1 == this.attachments.length ) {
                  this.messsage_loader = false;
                  let respPopUp = {
                    msg: response.data.message,
                    popup: true
                  }
                  EventBus.$emit( "success_resp", respPopUp );
                  setTimeout(() => {
                    if ( this.$route.name && this.$route.name == 'incidentExternalAction' ) {
                      this.hideFeedbackForm = ( update ) ? true : false;
                      this.incidentDetails();
                    } else
                      this.$router.push({ path: "/my-incidents" })
                  }, 2000);
                }
              })
              .catch(error => {
                if ( error.response.status == 400 ) {
                  this.messsage_loader = false;
                  let errorResp = {
                    msg: error.response.data.message,
                    popup: true
                  };
                  EventBus.$emit( "error_resp", errorResp );
                }
              });
          } else {
            if ( index + 1 == this.attachments.length ) {
              this.messsage_loader = false;
              let respPopUp = {
                msg: "Feedback saved successfully",
                popup: true
              }
              EventBus.$emit( "success_resp", respPopUp );
              setTimeout(() => {
                if ( this.$route.name && this.$route.name == 'incidentExternalAction' ) {
                  this.hideFeedbackForm = ( update ) ? true : false;
                  this.incidentDetails();
                } else
                  this.$router.push({ path: "/my-incidents" })
              }, 2000);
            }
          }
        }
      },
      updatePermission( assignToGroup, update, flag ) {
        // HTTP_formdata.post( "incident_reports/access_rights", { group: assignToGroup } )
        let api = ( this.$route.name && this.$route.name == 'incidentExternalAction' ) ? axios.post( BASE_URL_VER + "incident_reports/access_rights", { group: assignToGroup } ) : HTTP_formdata.post( "incident_reports/access_rights", { group: assignToGroup } )
          api.then(response => {
            if ( response.status == 200 ) {
              if ( this.attachments.length > 0 )
                this.attachmentUpload( update, flag );
              else {
                this.messsage_loader = false;
                let respPopUp = {
                  msg: response.data.message,
                  popup: true
                }
                EventBus.$emit( "success_resp", respPopUp );
                setTimeout(() => {
                  if ( this.$route.name && this.$route.name == 'incidentExternalAction' ) {
                    this.hideFeedbackForm = ( update ) ? true : false;
                    this.incidentDetails();
                  } else
                    this.$router.push({ path: "/my-incidents" })
                }, 2000);
              }
            }
          })
          .catch(error => {
            if ( error.response.status == 400 ) {
              this.messsage_loader = false;
              let errorResp = {
                msg: error.response.data.message,
                popup: true
              };
              EventBus.$emit( "error_resp", errorResp );
            }
          });
      },
      updateRootCauseSubOptions(rootcauseId) {
        console.log(rootcauseId, 'updateRootCauseSubOptions');
        const selectedRootCause = this.rootcauseOption.find(option => option.value === rootcauseId);
        console.log('selectedRootCause.subs', selectedRootCause.subs);
        if (selectedRootCause && selectedRootCause.subs) {
          this.rootcauseSubOption = selectedRootCause.subs.map(sub => ({
            value: sub.public_id,
            text: sub.subcategory
          }));
          //push { value: null, text: "Select", disabled: true } at the top
          this.rootcauseSubOption.unshift({ value: null, text: "Select", disabled: true });
          // this.incidentData.rootcause_sub = null;
        } else {
          this.rootcauseSubOption = [{ value: null, text: "Select", disabled: true }];
        }
      },
      resendFeedback() {
        // Add your resend logic here
        const payload = {
          incident_report_id: this.feedbackData.incident_public_id,
          incident_report_feedback_id: this.feedbackDetails[this.feedbackDetails.length -1].public_id,
          emailtype: ( this.feedbackDetails.length > 0 && this.feedbackDetails[this.feedbackDetails.length -1].status === "Reassigned" && (this.feedbackDetails[this.feedbackDetails.length -1].external_user !== null && this.feedbackDetails[this.feedbackDetails.length -1].external_user != "")) ? 'resent' : 'reminder',
        };
        console.log("Resend Feedback Payload:", payload);
        HTTP.post("incident_reports/resend_email", payload)
          .then((response) => {
            console.log("Resend Email Response:", response);
            if (response.status === 200) {
              this.$bvToast.toast("Email resent successfully!", {
                title: "Success",
                variant: "success",
                solid: true,
              });
            }
          })
          .catch((error) => {
            console.error("Error resending email:", error);
            this.$bvToast.toast("Failed to resend email. Please try again.", {
              title: "Error",
              variant: "danger",
              solid: true,
            });
          });
      },
      updateRiskAssessmentIndex() {
        const sev = this.feedbackData.riskAssessmentSeverity;
        const prob = this.feedbackData.riskAssessmentProbability;
        if (sev && prob) {
          const found = this.riskIndexOptions.find(
            opt => opt.sevOpt === sev && opt.proOpt === prob
          );
          this.feedbackData.riskAssessmentIndex = found ? found.text : "";
          this.feedbackData.riskAssessmentColour = found ? found.colour : "";
        } else {
          this.feedbackData.riskAssessmentIndex = "";
          this.feedbackData.riskAssessmentColour = "";
        }
        let riskAssessmentAction = '';
        if (this.feedbackData.riskAssessmentIndex) {
          const secondPart = this.feedbackData.riskAssessmentIndex.split(" ")[1];
          const match = this.risk_actions.find(a => a.matching === secondPart);
          if (match) {
            riskAssessmentAction = match.value;
          }
        }
        this.feedbackData.riskAssessmentAction = riskAssessmentAction;
      },
      updateRiskTreatmentIndex() {
        const sev = this.feedbackData.riskTreatmentSeverity;
        const prob = this.feedbackData.riskTreatmentProbability;
        if (sev && prob) {
          const found = this.riskIndexOptions.find(
            opt => opt.sevOpt === sev && opt.proOpt === prob
          );
          this.feedbackData.riskTreatmentIndex = found ? found.text : "";
          this.feedbackData.riskTreatmentColour = found ? found.colour : "";
        } else {
          this.feedbackData.riskTreatmentIndex = "";
          this.feedbackData.riskTreatmentColour = "";
        }
        let riskTreatmentAction = '';
        if (this.feedbackData.riskTreatmentIndex) {
          const secondPart = this.feedbackData.riskTreatmentIndex.split(" ")[1];
          const match = this.risk_actions.find(a => a.matching === secondPart);
          if (match) {
            riskTreatmentAction = match.value;
          }
        }
        this.feedbackData.riskTreatmentAction = riskTreatmentAction;
      }
    },
    created() {
      EventBus.$on("typeahead_search_internal_user", users => {
        this.feedbackData.externalEmail = users.username;
      });
    }
  };
</script>
<style>
  @import "../def_function.css";
  @import "../dashboard.css";

  .incident-logo{max-width: 315px;margin: 30px auto;}
  .incident-title{margin: auto;width: max-content;margin-bottom: 50px;}
  .label-right {display: flex; justify-content: space-between;}
  .dashboard-text {color: #333;font-size: 22px; margin: 5% 0;}
  .dashboard-text img {max-width: 35px;margin-top: -5px;}
  .info-span {color: #999;padding: 5px;}
  .issue-editor .ck.ck-content.ck-editor__editable {min-height: 200px;}
  .def-func-input-form-group .attachment-issue .custom-file label {min-height: 40px;border: 1px solid #a9a9a9;border-radius: 5px;padding: 10px;}
  .def-func-input-form-group .attachment-issue .custom-file label::after {height: 38px;padding: 8px 20px;font-size: 16px;background: #003261;color: white;font-weight: bold;letter-spacing: 0.03rem;}
  .textarea-no-resize {overflow-y: auto !important;}
  .incidentActionContainer {display: flex;margin-bottom: 20px;}
  .incidentActionContainer .dData {font-size: 16px; color:#003261;}
  .dTitle.desc{min-width: 102px;}
  .dTitle.sev{min-width: 75px;}
  .dTitle.title{min-width: 45px;}
  .dTitle.station{min-width: 65px;}
  .incidentActionContainer .dTitle {color: grey;font-size: 16px;margin-right: 10px;}
  .attachmentImghover svg {font-size: 20px;color: #0e3d69; cursor:pointer; outline: none;}
  .attachmentImghover img {width: 20px; cursor:pointer; outline: none;}
  .attachmentImghover{position: absolute;top: 50%;left: 50%;white-space: nowrap;transform: translate(-50%,-50%);}
  .attachmentData {display: flex;justify-content: space-between;}
  .attCol{flex-direction: column;}
  .att{display: flex;margin-bottom: 10px;}
  .incidentActionImages .card{border: 1px solid #e8ecf1; border-radius: 5px; padding: 5px;}
  .incidentActionImages .card-body{padding: 0;background-color: white;}
  .incidentActionImages [class*=col-]:first-child{margin-left: 8.333333%;}
  .incidentActionImages .card-footer img{width: 12px; outline: none;}
  .carousel-caption h3{font-size: 12px; }
  .attachmentImghover{display: none;}
  .incidentActionImages .card:hover .attachmentImghover{display: block;    min-width: 60px;display: flex;justify-content: space-around;}
  .incidentActionImages .card:hover > img{opacity: 0.4;}
  .incidentActionContainer2 {display: flex;flex-direction: column;margin-bottom: 20px;}
  .attModal .modal-body{text-align: center;}
  .attModal img{ width: 100%;}
  .reportIncidentImages [class*=col-]:first-child,.reportIncidentImages [class*=col-]:nth-child(6n) {margin-left: 8.333333%;}
  .incidentActionImages [class*=col-]:first-child{margin-left: 8.333333%;}
  .outer_reset .inner_404 {position: relative; top: initial; transform: translateY(0); padding: 25px 30px 0;}
  .outer_reset .btn {background: white; border: 1px solid #003261; border-radius: 5px; color: #031d38; padding: 0 15px; height: 40px; position: relative;}
  .progress-bar.progress-label {flex-direction: initial; padding: 3px; font-size: 15px; background-color: #003261;}
  .progress-bar.progress-label strong {line-height: 24px; padding: 0 1px 0 5px;}
  .outer_reset .body_404 {margin: 30px 0 20px;}
  .outer_reset .body_404 strong { font-size: 20px; }
  .title_404 {font-size: 30px; letter-spacing: 0px;}
  .pdf-button-container{background-color: #ebebeb !important;}
  .pdf-button{font-size: 16px;background-color: #003261;color: white;position: relative;padding-left: 50px;min-width: 160px;border: none;box-shadow: 2px 2px 4px #8b8b8b;}
  .pdf-button-img{width: 46px;background-color: white;padding: 6px;border-radius: 4px;box-shadow: 2px 2px 4px #8b8b8b;position: absolute;left: -4px;top: -8px;}
  .pdf-button-container .carousel-caption{bottom: 32%;}
  .resend-btn{min-width: 120px;margin-left: auto;}
  .resend-btn:hover{background: inherit; color: inherit; border-color: inherit}
  .d-flex {display: flex;}
  .pl0 {padding-left: 0}
  .pr0 {padding-right: 0}
  .unacceptable, .unacceptable:disabled { background: #e92828; color: #f2f2f2; border: 4px solid #ff7d7d; transition: all 0.5s ease;}
  .review, .review:disabled { background: #ffc823; border: 4px solid #FFDB58; transition: all 0.5s ease;}
  .acceptable, .acceptable:disabled { background: #028a0f;  color: #f2f2f2; border: 4px solid #38b043; transition: all 0.5s ease;}
  .dData.riskIndex-acceptable, .dData.riskIndex-review, .dData.riskIndex-unacceptable {padding: 4px 10px; font-size: 14px; border-radius: 8px; min-width: 140px; text-align: center;}
  .dData.riskIndex-review {background: #ffc823;  border: 4px solid #FFDB58;}
  .dData.riskIndex-unacceptable {background: #e92828; color: #f2f2f2; border: 4px solid #ff7d7d;}
  .dData.riskIndex-acceptable {background: #028a0f; color: #f2f2f2; border: 4px solid #38b043;}
  @media only screen and (max-width: 1200px){
    .incidentActionImages [class*=col-]:nth-child(6n) {margin-left: 8.333333%;}
  }
  @media only screen and (max-width: 768px){
    .reportIncidentImages [class*=col-]:first-child,.reportIncidentImages [class*=col-]:nth-child(6n) {margin-left: 0;}
    .incidentActionImages [class*=col-]:first-child,.incidentActionImages [class*=col-]:nth-child(6n) {margin-left: 0;}
  }
</style>